<template>
    <div class="v-text"
         @mouseenter="show"
         @mouseleave="hide"
    >
        <div class="v-text__text-container">
            <div ref="text" class="v-text__text">{{ _text }}</div>
            <slot v-if="!isEllipsis"></slot>
        </div>

        <div ref="fullText" class="v-text__container" v-if="isEllipsis">
            <span>{{ text }}</span>
            <slot></slot>
        </div>
    </div>
</template>

<script>
import {createPopper} from "@popperjs/core"

export default {
    name: 'v-text',

    props: {
        text: {
            type: String,
            required: true
        },

        ellipsis: {
            type: Number,
            default: 25
        }
    },

    data() {
        return {
            isEllipsisResult: false,
            instance: null
        }
    },

    computed: {
        _text() {
            if (this.isEllipsis) {
                return this.text.slice(0, this.ellipsis) + '...'
            } else {
                return this.text
            }
        },

        isEllipsis() {
            return this.text.length >= this.ellipsis
        }
    },

    methods: {
        instancePopper() {
            return createPopper(this.$refs.text, this.$refs.fullText, {
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -31],
                        }
                    },
                    {
                        name: 'flip',
                        options: {
                            fallbackPlacements: ['bottom-start'],
                        }
                    },
                    {
                        name: 'preventOverflow',
                        options: {
                            padding: -10,
                        }
                    }
                ]
            })
        },

        show() {
            if (this.isEllipsis) {
                this.$refs.fullText.setAttribute('data-show', '')

                this.instance = this.instancePopper()
            }
        },

        hide() {
            if (this.isEllipsis) {
                this.$refs.fullText.removeAttribute('data-show')

                this.instance.destroy()
                this.instance = null
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.v-text {
    position: relative;

    &__text {
        white-space: nowrap;

        &-container {
            display: flex;
            align-items: center;
        }
    }

    &__container {
        background-color: #fff;
        padding: 10px;
        border-radius: 10px;
        box-shadow: 0 0 8px -1px rgba(0, 0, 0, 0.45);
        display: none;

        span {
            white-space: nowrap;
        }

        &[data-show] {
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
}
</style>
